import React from 'react';

function Avatar({ name, photo, size = 'md', className = '' }) {
  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
    xl: 'w-16 h-16 text-lg',
  };

  return (
    <div
      className={`avatar ${sizeClasses[size]} ${className}`}
      style={{
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: photo ? 'transparent' : 'var(--gradient-primary)',
        color: photo ? 'inherit' : 'white',
        overflow: 'hidden',
        flexShrink: 0,
      }}
    >
      {photo ? (
        <img src={photo} alt={name || 'Avatar'} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      ) : (
        <span className="avatar-placeholder">{getInitials(name)}</span>
      )}
    </div>
  );
}

export default Avatar;

